var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100",class:_vm.dynamicClass},_vm._l((new Array(8)),function(i){return _c('span',{key:i,staticClass:"material-icons md-12"},[_vm._v("emergency")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }